import type { VoidComponent } from "solid-js";
import { untrack } from "solid-js";
import type { Id } from "@thisbeyond/solid-dnd";
import { createDraggable, createDroppable } from "@thisbeyond/solid-dnd";
import DropZone from "../../components/field/dropZone/DropZone";
import type { TranslationKey } from "../../state/i18n";
import { useTranslation } from "../../state/i18n";
import type { Stringifiable } from "../../types";

export type MovableItem<T extends Stringifiable> = {
  id: T;
  name: string;
  title: TranslationKey;
  Preview: VoidComponent<{
    id: T;
  }>;
  Overlay: VoidComponent<{
    id: T;
  }>;
};

const Moveable = <T extends Stringifiable>(props: { item: MovableItem<T>; ignoredZones: Id[] }) => {
  const { t } = useTranslation();
  const { id, title, Overlay } = untrack(() => props.item);
  const draggable = createDraggable(id.toString(), {
    overlay: () => <Overlay id={id} />,
  });
  const droppable = createDroppable(id.toString());

  return (
    <article aria-label={`${t(title)} - ${props.item.name}`} class="relative">
      {/* oxlint-disable-next-line better-tailwindcss/no-restricted-classes */}
      <div class="absolute top-[-5px] w-full" use:droppable>
        <DropZone active={droppable.isActiveDroppable && !props.ignoredZones.includes(id.toString())} />
      </div>
      <div classList={{ "opacity-50": draggable.isActiveDraggable }} ref={draggable.ref}>
        <props.item.Preview id={id} />
      </div>
    </article>
  );
};

export default Moveable;
